import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c81b288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepDeliveryTimeSlots" }
const _hoisted_2 = { class: "px-6 py-4 bg-white border flex flex-col gap-2" }
const _hoisted_3 = { class: "StepDeliveryTimeSlots__title" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        (_ctx.cargo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.cargo.deliveryTimeSlot)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Перевыберите тайм-слот при доставке для созданного груза")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Выберите тайм-слот при доставке")
                  ], 64))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Выберите тайм-слот при доставке")
            ], 64))
      ]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата доставки",
        value: _ctx.date_state.date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date_state.date) = $event)),
        min: _ctx.date_state.minimumDeliveryDay,
        max: _ctx.date_state.maximumDeliveryDay,
        disabled: _ctx.disabled || _ctx.date_state.is_loading,
        onChange: _ctx.onDateChange
      }, null, 8, ["value", "min", "max", "disabled", "onChange"]),
      _createVNode(_component_the_select, {
        searchable: false,
        value: _ctx.state.timeSlot?.id,
        loading: _ctx.state.is_loading,
        failed: _ctx.state.is_failed,
        options: _ctx.state.list,
        disabled: _ctx.disabled || !Boolean(_ctx.date_state.date),
        onChange: _ctx.onTimeSlotChange
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.timeFrom) + " - " + _toDisplayString(option.timeTo), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.timeFrom) + " - " + _toDisplayString(option.timeTo), 1)
        ]),
        _: 1
      }, 8, ["value", "loading", "failed", "options", "disabled", "onChange"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          type: "button",
          class: "text primary small",
          disabled: _ctx.disabled || !_ctx.state.timeSlot,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Продолжить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}